<template>

  <main class="main-content" id="topDom">
    <section class="section --banner">
      <div class="banner">
        <div class="banner__bg">
          <img :src="bgImg" />
        </div>
        <div class="banner__content container-fluid">
          <div class="row align-items-center">
            <div class="col-12 col-md-6 order-2 order-md-1">
              <h1 class="banner__title">{{ $t("i18n.jszkMemberLogin") }}</h1>
            </div>
          </div>
        </div>
      </div>

      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="login-header">
              <div class="login-header-text">
                <h1 style="font-size: 32px;font-weight: 500;">{{ $t("i18n.jszkMemberLogin") }}</h1>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="login-form">
              <div class="login-title">
                <div class="login-title-text">
                  <span>{{ $t("i18n.memberLogin") }}</span>
                </div>
              </div>
              <div class="login-inputs">
                <div class="login-input-username">
                  <input type="text" class="form-input --name" :placeholder="$t('i18n.userNameRequired')" name="userName" v-model="form.mobile">
                </div>
                <div class="login-input-password">
                  <input type="passWord" class="form-input --password" :placeholder="$t('i18n.passWordRequired')" name="passWord" v-model="form.password">
                </div>
              </div>
            </div>

            <div class="login-footer">
              <div class="login-button" @click="goLogin">
                <span>{{ $t("i18n.login") }}</span>
              </div>
              <div class="forget-password" @click="toPage('retrievePassword')">
                <span>{{ $t("i18n.forgetPassword") }}</span>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="login-register">
              <div class="register-text">
                <h2 style="font-size: 26px;font-weight: 500;">{{ $t("i18n.notMember") }}</h2>
              </div>
              <div class="register-btn" @click="toPage('register')">
                <div class="register-btn-text">
                  <h4 style="font-weight: 500;font-size: 2rem;">{{ $t("i18n.quicklyRegister") }}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import { login } from "../api/api";
import { Message } from 'element-ui'
export default {
  name: "login",
  data() {
    return {
      form: {},
      bgImg: this.isMobile() ? require("../assets/imgs/loginBg.png") : require("../assets/imgs/loginBg.png"),
    }
  },
  // created() {
  //   this.goTop();
  // },
  mounted () {
    this.goTop();
  },
  methods: {
    goLogin() {
      if (!this.form.mobile) {
        Message({
          message: this.$t('i18n.userNameRequired'),
          // message: error.message,
          type: 'error',
          duration: 3 * 1000
        });
        return;
      }
      if (!this.form.password) {
        Message({
          message: this.$t('i18n.passWordRequired'),
          // message: error.message,
          type: 'error',
          duration: 3 * 1000
        });
        return;
      }
      login(this.form).then(res => {
        if (res.data && res.data.code) {
          Message({
            message: this.$t('i18n.loginSuccess'),
            // message: error.message,
            type: 'success',
            duration: 3 * 1000
          });
          localStorage.setItem("token", res.data.token);
          this.$store.commit('updateLogin', true);
          this.flg = true;
          this.form = {};
          this.$router.push("/");
        } else {
          Message({
            message: res.data.msg,
            // message: error.message,
            type: 'error',
            duration: 3 * 1000
          });
        }
      })
    },
    isMobile() {
      return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    },
    toPage(path) {
      this.$router.push(path)
    },
    goTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' }); // 平滑滚动到顶部
      // document.querySelector('#topDom').scrollIntoView({
      //   behavior: 'smooth'
      // })
    },
  },
}
</script>

<style scoped>

.banner {
  height: 64rem;
  align-items: center;
  display: flex;
}
.banner__bg {
  position: absolute;
  width: 100%;
  height: 64rem;
}
.banner__bg {
  z-index: 1;
}

.banner__bg img {
  max-width: 100%;

  display: block;
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
  -o-object-position: 50% 50%;
  object-position: 50% 50%;
}
img {
  max-width: 100%;
}
.banner__content {
  position: relative;
  z-index: 2;
}
.banner__title {
  font-size: 3.8rem;
  letter-spacing: -.084rem;
  line-height: 6rem;
  margin-bottom: 2rem;
  padding-right: 2rem;
  color: #FFFFFF;
  font-weight: 400;
}
.login-header {
  width: 100%;
  height: 6rem;
  background-color: #5A246B;
  margin-top: 10rem;
  border-radius: 1rem;
}
.login-header-text {
  color: #FFFFFF;
  font-size: 2rem;
  letter-spacing: -.022rem;
  line-height: 4rem;
  font-weight: normal;
  padding-top: 1rem;
  margin-left: 6rem;
}
.login-header-text h1 {
  margin: 0;
}
.login-header-text:after {
  content: "";
  width: 3.5rem;
  height: 3.5rem;
  background: url(../assets/imgs/select-arrow-big.png) no-repeat 50%;
  position: absolute;
  left: 50rem;
  bottom: 1rem;
}
.login-title {
  border-bottom: 1px solid #ddd;
  margin-top: 3rem;
  margin-bottom: 3rem;
  color: #5A246B;
}
.login-title-text {
  display: flex;
  justify-content: center;
  font-weight: 600;
  font-size: 16px;
  margin-right: 0.2rem;
  padding: 1rem 1.5rem;
  border: 1px solid #d2d0cf;
  border-bottom-color: transparent;
  cursor: pointer;
  background-color: #fff;
  width: 12rem;
  margin-left: 3rem;
  margin-bottom: -.2rem;
}
.login-form {
  margin-bottom: 3rem;
}
.login-inputs {
  margin-top: 4rem;
}
.login-input-username {
  margin-bottom: 3rem;
}

.form-input, input[type=email], input[type=text] {
  width: 40rem;
  height: 5rem;
  border-radius: 1rem;
  padding-bottom: 0;
}
.login-input-username:before {
  content: "";
  width: 3.8rem;
  height: 3.8rem;
  position: absolute;
  z-index: 2;
  background-image: url(../assets/imgs/userNameImg.png);
	background-repeat: no-repeat;
	background-position: center center;
	background-size: 60%;
  top: 40%;
  left: 2.3rem;
  transform: translateY(-50%);
}
 .login-input-password:before {
   content: "";
   width: 3.8rem;
   height: 3.8rem;
   position: absolute;
   z-index: 2;
   background-image: url(../assets/imgs/passwordImg.png);
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 60%;
   top: 60%;
   left: 2.3rem;
   transform: translateY(-50%);
 }
.form-input {
  padding-left: 6rem;
}
.login-footer {
  margin-bottom: 4rem;
  display: flex;
}
.login-button {
  cursor: pointer;
  width: 15rem;
  height: 5rem;
  background-color: #5A246B;
  border-radius: 1rem;
  font-size: 2rem;
  color: white;
  align-items: center;
  display: flex;
  justify-content: center;
}
.forget-password {
  cursor: pointer;
  margin-top: 2rem;
  margin-left: 2rem;
  font-size: 1.3rem;
  font-weight: 500;
}
.login-register {
  margin-left: 20rem;
  margin-top: 15rem;
}
.register-btn {
  cursor: pointer;
  width: 20rem;
  height: 5rem;
  background-color: #5A246B;
  border-radius: 1rem;
  font-size: 2rem;
  color: white;
  align-items: center;
  display: flex;
  justify-content: center;
}
.register-btn-text {
  margin-left: 3rem;
}
.register-btn:after {
  content: "";
  width: 3rem;
  height: 3rem;
  margin-left: auto;
  background: #ffffff;
  -webkit-mask: url(../assets/imgs/arrow-right-big.svg) no-repeat center;
  mask: url(../assets/imgs/arrow-right-big.svg) no-repeat center;
  transition-property: all;
  transition-duration: .3s;
}
@media (max-width: 768px) {
  .register-input{
    margin-left: 0;
  }
  .register-input-text{
    font-size: 1.5rem;
  }
  .invalid-feedback{
    font-size: 1.5rem;
  }
  .form-input{
    width: 100% !important;
  }
  .register-btn{
    width: 100% !important;
  }
  .login-header-text{
    text-align: center;
    margin-left: 0;
  }
  .login-register{
    margin-left: 0;
    text-align: center
  }
}
</style>



// WEBPACK FOOTER //
// src/view/login.vue